import { RefObject, useCallback, useEffect } from 'react';

const useOutsideClick = (
  ref: RefObject<HTMLElement>,
  callback: () => void,
  opened: boolean,
): void => {
  const handleClick = useCallback(
    (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        callback();
      }
    },
    [ref, callback],
  );

  useEffect(() => {
    if (opened) {
      setTimeout(() => {
        document.addEventListener('mousedown', handleClick);
      }, 0);
    }
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [ref, callback, opened, handleClick]);
};

export default useOutsideClick;
